<template>
  <el-card v-loading="loading">
    <template slot="header">
      修改
    </template>
    <el-form :model="Banner"
             :rules="rules"
             ref="ruleForm"
             label-position="right"
             label-width="80px">
      <el-form-item label="图片地址" prop="img_path">
        <img-upload :v-model="Banner.img_path" :return-url="true" :default-url="Banner.img_path" @input="setImg"></img-upload>
      </el-form-item>
      <el-form-item label="图片说明" prop="desc">
        <el-input v-model="Banner.desc"></el-input>
      </el-form-item>
      <el-form-item label="跳转地址" prop="href">
        <el-input v-model="Banner.href">
          <template slot="prepend"></template>
        </el-input>
      </el-form-item>
      <el-form-item label="匹配url" prop="match_url">
        <el-input v-model="Banner.match_url"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="Banner.sort"></el-input-number>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="update('ruleForm')">保存</el-button>
        <el-button type="success" @click="back">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import {mapState} from 'vuex'
  import '@/static/test'
  import ImgUpload from "../img/ImgUpload";

  export default {
    name: "BannerEdit",
    props: {
      id: {
        required: true
      }
    },
    components: {ImgUpload},
    data() {
      return {
        banner: {}
      }
    },
    computed: {
      ...mapState({
        Banner: state => state.banner.Banner,
        rules: state => state.banner.rules,
        loading: state => state.banner.loading
      })
    },
    methods: {
      back() {
        this.$router.back();
      },
      setImg(value){
        this.$store.commit('banner/setBanner', {...this.Banner, img_path: value});
      },
      update(form) {
        let vthis = this;

        this.$refs[form].validate((validate) => {
          if (!validate) {
            return;
          }
          this.$store.dispatch('banner/update').then(res => {
            vthis.$confirm('是否关闭页面?')
              .then(_ => {
                vthis.$router.back();
              });
          })
            .catch(res => {
              console.log(res);
            });
        });

      }
    },
    created() {
      this.$notify({
        title: '提醒',
        dangerouslyUseHTMLString:true,
        message: 'banner图的最佳尺寸为：<br><span style="font-weight: 500; color: #db0000;">682px * 427px</span><br>不是此比例的图片，可能会导致变形',
        type: 'warning'
      });
      this.$store.dispatch('banner/show', {id: this.id});
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/banner/BannerEdit.vue